import { queryOptions } from '@tanstack/react-query';

import { getResponse } from '@/utils';

export const getApiV1AuthAccess = queryOptions({
  queryKey: ['getApiV1AuthAccess'],
  queryFn: () => getResponse('getApiV1AuthAccess'),
});
